module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notice"
  }, [_c('div', {
    staticClass: "noticeHead"
  }, [_vm._v("\n        提示\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.params.noticeText))]), _vm._v(" "), _c('div', {
    staticClass: "noticeBottom"
  }, [_c('button', {
    staticClass: "ensure2 button green",
    on: {
      "click": _vm.ensure
    }
  }, [_vm._v("确定")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ac3b3c6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notice/notice2.vue
// module id = 1199
// module chunks = 1